import React from 'react';
import { IUserInfo } from 'gen/ApiClient';

interface IProps {
    user: IUserInfo,
}

export const LoggedInUserContext = React.createContext<IProps>(undefined as any);
